import { render } from "./filter-tags.vue?vue&type=template&id=46dfc540"
import script from "./filter-tags.vue?vue&type=script&lang=js"
export * from "./filter-tags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__